import React from "react";
import { unitCellClass, formatPrice, STATUS_LEGEND, statusStyle } from "@/lib/constants";

/**
 * Reusable stock map view.
 * Props: blocks (with floors -> units), currentBlockId, setCurrentBlockId, onUnitClick
 */
export default function StockMapView({ blocks, currentBlockId, setCurrentBlockId, onUnitClick, compact = false }) {
  const block = blocks?.find((b) => b.id === currentBlockId) || blocks?.[0];

  if (!blocks || blocks.length === 0) {
    return <div className="bg-white border border-slate-200 rounded-xl p-8 text-center text-slate-500">Bu projede henüz blok yok.</div>;
  }

  return (
    <div className="space-y-4" data-testid="stock-map-view">
      {/* Block selector */}
      <div className="flex items-center gap-2 flex-wrap" data-testid="block-selector">
        {blocks.map((b) => (
          <button key={b.id} onClick={() => setCurrentBlockId(b.id)}
                  data-testid={`block-tab-${b.id}`}
                  className={`px-4 py-2 rounded-lg text-sm font-medium transition ${(currentBlockId === b.id || (!currentBlockId && b.id === blocks[0].id))
                    ? "bg-slate-900 text-white" : "bg-white border border-slate-200 text-slate-700 hover:border-slate-300"}`}>
            {b.name}
          </button>
        ))}
      </div>

      {/* Legend */}
      <div className="flex items-center gap-3 flex-wrap text-xs text-slate-600">
        {STATUS_LEGEND.map((status) => {
          const s = statusStyle(status);
          return (
          <span key={status} className="inline-flex items-center gap-1.5">
            <span className="w-3 h-3 rounded-sm" style={{ background: s.color }} /> {s.label}
          </span>
        );})}
      </div>

      {/* Floors */}
      <div className="space-y-3" data-testid="floors-list">
        {(block?.floors || []).map((floor) => (
          <div key={floor.id} className="bg-white border border-slate-200 rounded-xl p-4">
            <div className="flex items-center justify-between mb-3">
              <div>
                <div className="text-sm font-semibold text-slate-900" data-testid={`floor-name-${floor.id}`}>{floor.name}</div>
                <div className="text-xs text-slate-500">{floor.floor_type} • {floor.units?.length || 0} bölüm</div>
              </div>
            </div>
            <div className={`grid gap-2 ${compact ? "grid-cols-3 sm:grid-cols-5 lg:grid-cols-8" : "grid-cols-2 sm:grid-cols-4 lg:grid-cols-6 xl:grid-cols-8"}`}>
              {(floor.units || []).map((u) => (
                <button key={u.id} onClick={() => onUnitClick?.(u)}
                        className={`unit-cell ${unitCellClass(u.status)}`}
                        data-testid={`unit-cell-${u.id}`}
                        title={`${u.unit_no} • ${u.room_type} • ${formatPrice(u.price, u.currency)} • ${u.status}`}>
                  <div className="text-sm font-bold leading-tight">{u.unit_no}</div>
                  <div className="text-[10px] opacity-90 mt-0.5">{u.room_type}</div>
                  <div className="text-[10px] opacity-90">{formatPrice(u.price, u.currency)}</div>
                </button>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
